import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import workflowRepository from "../../repository/WorkflowRepository";
import {Workflow, WorkflowCreate} from "@/model/Workflow";


const useCreateWorkflow = () => {
    const queryClient = useQueryClient();

    return useMutation<Workflow, AxiosError, WorkflowCreate>({
        mutationKey: ["workflow", "create"],
        mutationFn: async (body: WorkflowCreate) => {
            try {
                const {data} = await workflowRepository.create(body);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["workflows"],
                exact: false
            })
        }
    })
};
export default useCreateWorkflow